import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import withLocation from "../../withLocation";
const service = new Service();


class PhotodetDashboard extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        let initialData = [];
        
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData
        }
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
        // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var conID = reqUrl.split('/')[3];
        var memID = reqUrl.split('/')[4];
        // console.log('ConDetailUrl: ',ConDetailUrl);

        var url = global.api_url + "contest/getdashboard";
        let body = JSON.stringify({ 
                    "pageNo": 1,
                    "pageSize": 10 ,
                    "contestId": conID,
                    "memoryId": memID    
                })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        if(navigator.onLine) {
            console.log(">>>>>>>",this.state.initialData);

            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
            } else {
                localStorage.setItem('photoDashboard', JSON.stringify(this.state.initialData));
            }
        
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
            } else {
                localStorage.setItem('photoDashboard', JSON.stringify(this.state.initialData));
            }
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
    } 

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title="Capture Your Baby Bump Week by Week - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." },
                        { "name": "ROBOTS", "content": "all" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a className="R11_9e" href="/baby-photo-contest">Memories Contest</a></span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Winners</h1>
                </div>
                <div className="sub-container memoriesContest-cnt left">
                    <div className="data-container left">
                        <div className="container_bump">
                        {/* start */}
                        <div className="photodet-dashboard">
                            <div className="parti-position">
                                <p className="pos-title R14_pink"><span>Santosh</span> Position in Contest</p>
                                <table className="parti-pos">
                                    <tbody>
                                        <tr>
                                            <th className="B13_42">Rank </th>
                                            <th className="B13_42">Name</th>
                                            <th className="B13_42">Likes</th>
                                            <th className="B13_42">Comments</th>
                                            <th className="B13_42">Total</th>
                                        </tr>
                                        {this.state.initialData.result.loginUserRank && this.state.initialData.result.loginUserRank.length >1 ?
                                        this.state.initialData.result.loginUserRank.map((rowlogin, index) =>
                                        <tr key={rowlogin.index}>
                                            <td className="R14_42">{rowlogin.rank}</td>
                                            <td className="R14_42">{rowlogin.userName}</td>
                                            <td className="R14_42">{rowlogin.likeCount}</td>
                                            <td className="R14_42">{rowlogin.commentCount}</td>
                                            <td className="R14_42">{rowlogin.total}</td>
                                        </tr>
                                        )
                                        :
                                        <tr>
                                            <td className="R14_42" colSpan="5" style={{textAlign:'center'}}>Record not found</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="parti-dashboard">
                                <p className="dash-title R14_pink"><span>Fashion Crazy Contest</span> Dashboard</p>
                                <table className="dashboard-tbl">
                                    <tbody>
                                        <tr>
                                            <th className="B13_42">Rank</th>
                                            <th className="B13_42">Name</th>
                                            <th className="B13_42">Likes</th>
                                            <th className="B13_42">Comments</th>
                                            <th className="B13_42">Total</th>
                                        </tr>
                                        {this.state.initialData.result.dashboardList && this.state.initialData.result.dashboardList.length >1 ?
                                        this.state.initialData.result.dashboardList.map((row, index) =>
                                        <tr key={row.index}>
                                            <td className="R14_42">{row.rank}</td>
                                            <td className="R14_42">{row.userName}</td>
                                            <td className="R14_42">{row.likeCount}</td>
                                            <td className="R14_42">{row.commentCount}</td>
                                            <td className="R14_42">{row.total}</td>
                                        </tr>
                                        )
                                        :
                                        <tr>
                                            <td className="R14_42" colSpan="5" style={{textAlign:'center'}}>Record not found</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* end */}
                        </div> 
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withLocation(PhotodetDashboard);